import { FormPagePropertyItemText } from 'backend';
import { RE_ENTER_PROPERTY_ID_PREFIX } from 'reEnter';
import { TEXT_PROPERTY_INPUT_TYPE } from 'shared';
import { PropertyItemElement } from '.';

export const getTextPropertyItemElement = (
  propertyItem: FormPagePropertyItemText,
): PropertyItemElement => {
  switch (propertyItem.inputFormat.inputType) {
    case TEXT_PROPERTY_INPUT_TYPE.singleLine: {
      const text = document.querySelector<HTMLElement>(
        `input[id="${propertyItem.propertyId}"]`,
      );
      if (!text) return {};
      const reEnter = document.querySelector<HTMLElement>(
        `input[id="${RE_ENTER_PROPERTY_ID_PREFIX}${propertyItem.propertyId}"]`,
      );
      if (!reEnter) {
        return { text: text };
      }
      return {
        text: text,
        reEnter: reEnter,
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.multiLine: {
      const textArea = document.querySelector<HTMLElement>(
        `textarea[id="${propertyItem.propertyId}"]`,
      );
      if (!textArea) {
        return {};
      }
      return {
        textArea: textArea,
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.name: {
      const lastName = document.querySelector<HTMLElement>(
        `input[name="last-name"][id="${propertyItem.propertyId}"]`,
      );
      const firstName = document.querySelector<HTMLElement>(
        `input[name="first-name"][aria-labelledby="label-${propertyItem.propertyId}"]`,
      );
      if (!lastName || !firstName) {
        return {};
      }
      return {
        lastName: lastName,
        firstName: firstName,
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.tel: {
      const first = document.querySelector<HTMLElement>(
        `input[name="${propertyItem.propertyId}-first"]`,
      );
      const second = document.querySelector<HTMLElement>(
        `input[name="${propertyItem.propertyId}-second"]`,
      );
      const third = document.querySelector<HTMLElement>(
        `input[name="${propertyItem.propertyId}-third"]`,
      );
      if (!first || !second || !third) {
        return {};
      }
      return {
        first: first,
        second: second,
        third: third,
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.zipCode: {
      const first = document.querySelector<HTMLElement>(
        `input[name="${propertyItem.propertyId}-first"]`,
      );
      const second = document.querySelector<HTMLElement>(
        `input[name="${propertyItem.propertyId}-second"]`,
      );
      if (!first || !second) {
        return {};
      }
      return {
        first: first,
        second: second,
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.zipCodeWithoutHyphen: {
      const zipCode = document.querySelector<HTMLElement>(
        `input[id="${propertyItem.propertyId}"]`,
      );
      if (!zipCode) {
        return {};
      }
      return {
        zipCode: zipCode,
      };
    }
    case TEXT_PROPERTY_INPUT_TYPE.additionalText: {
      const text = document.querySelector<HTMLElement>(
        `input[id="${propertyItem.propertyId}"]`,
      );
      if (!text) return {};
      return {
        text: text,
      };
    }
  }
};
